import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { INotification, NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'flow-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {


  notifications : INotification[] = [];

  constructor(
    private notification : NotificationService,
    private router : Router

  ) {
    this.notification.$notifications.subscribe((notifications : INotification[]) => this.notifications = notifications);
  }

  get notificationCount () : number {
    return this.notification.$notificationCount.getValue();
  };

  

  isOverlayVisible: boolean = false;

  showOverlay() {
    this.isOverlayVisible = true;
  }

  hideOverlay() {
    this.isOverlayVisible = false;
  }

  goto(_path: string) {
    this.router.navigate([_path]);
    this.hideOverlay();
  }
  
}
